import {
    defaultSelectedSubline
} from "./state";

export function setSublines(state, sublines) {
    state.sublines = sublines;
}

export function setSubline(state, subline) {
    state.selectedSubline = JSON.parse(JSON.stringify(subline));
    state.sublineTemplateAccounts = subline.subline_template_accounts || [];
}

export function setActionSublines(state, action) {
    state.actionSubline = action;
}

export function sublineError(state, error) {
    state.error = true
    state.errorMessage = error
}

export function setAccountsInventory(state, accountsInventory) {
    state.accountsInventory = accountsInventory
}

export function setAccountsCost(state, accountsCost) {
    state.accountsCost = accountsCost
}

export function setAccountsSales(state, accountsSales) {
    state.accountsSales = accountsSales
}


//Establece el valor por defecto de selectedSubline
export function resetSelectedSubline(state) {
    let id = state.selectedSubline.id
    Object.assign(state.selectedSubline, defaultSelectedSubline())
    state.sublineTemplateAccounts = [];
    if (id) {
        state.selectedSubline.id = id
    }
}

export function setSublineList(state, data) {
    state.sublinesList = data;
}

export function setSublineTemplateAccounts(state, data) {
    state.sublineTemplateAccounts = data;
}

export function setSublineModels(state, data) {
    state.sublineModels = data;
}

export function addSublineTemplateAccountRow(state, row) {
    state.sublineTemplateAccounts.push(row);
}

export function setSublineTemplateAccount(state, row) {
    const index = state.sublineTemplateAccounts.findIndex(item => {
        return (row.id && item.id === row.id) || (row.local_id && item.local_id === row.local_id);
    });

    if (index >= 0) {
        state.sublineTemplateAccounts.splice(index, 1, row);
    } else {
        state.sublineTemplateAccounts.push(row);
    }
}

export function removeSublineTemplateAccount(state, row) {
    state.sublineTemplateAccounts = state.sublineTemplateAccounts.filter(item => {
        return row.id ? item.id !== row.id : item.local_id !== row.local_id;
    });
}


// WEBPACK FOOTER //
// ./src/modules/sublines/mutations.js